import barra from "../../general/barra/barra.vue";
import barrais from "../../general/barrais/barrais.vue";
import foot from "../../general/foot/foot.vue";
import barrade from "../../general/barrade/barrade.vue";
import mixx from "../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "cuponesLiquidados",
  data() {
    return {
      msg: "-",
      loading: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      }
    };
  },
  mounted() {
    $("#cont_r").css("min-height", window.innerHeight - 101 + "px");
    this.tbv = $("#ventas").DataTable({
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      order: [],
      autoWidth: true,
      orderCellsTop: true,
      fixedHeader: true,
      rowCallback: function(row, data, index) {}
    });
    $(".box").boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function() {
      return (
        "/billeteras/gocuotas/cupones/liquidados?desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post("/billeteras/gocuotas/cupones/liquidados", this.f_c)
        .then(response => {
          response.data.data.forEach(element => {
            element[6] = this.num_to_many(element[6]);
            element[8] = this.num_to_many(element[8]);
            element[9] = this.num_to_many(element[9]);
            element[10] = this.num_to_many(element[10]);
            element[11] = this.num_to_many(element[11]);

            this.tbv.row.add(element);
          });
          this.tbv.draw();
          this.loading = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/reportes/goCuotasCuponesLiq/index.js